module.exports = {
  customClassName: '',
  customPlaceholder: 'Search...'
};
